import React from 'react'
import '../css/index.scss'

export function LoadingSpinner({label = 'Lädt…', className = '', size = 'md'}) {
  return (
    <div className={`loading-spinner ${className}`.trim()} aria-busy="true" aria-live="polite">
      <div className={`loading-spinner__circle loading-spinner__circle--${size}`} />
      {label ? <div className="loading-spinner__label">{label}</div> : null}
    </div>
  )
}

